import type { IconName } from "../icon/Icon";
import type { Category } from "../../types";
import type { VoidComponent } from "solid-js";
import { Show } from "solid-js";
import type { ValidationError } from "../../utils/validationParserUtil";
import { getIconCategoryColor } from "../../utils/iconColorUtil";
import Text from "../text/Text";
import { DynamicValueIconTile } from "../icon/IconTile";
import { useTranslation } from "../../state/i18n";

type GenericErrorCardProps = {
  icon: IconName;
  iconColor?: string;
  label: string;
  errors: ValidationError[];
  onClick: () => void;
};

type BaseErrorCardProps = {
  category?: Category;
} & GenericErrorCardProps;

const BaseErrorCard: VoidComponent<BaseErrorCardProps> = (props) => {
  const { t } = useTranslation();

  return (
    <button
      class="flex w-full min-w-0 flex-col gap-2 bg-surface-default px-3 py-2.5 hover:bg-surface-hover focus-visible:outline-default"
      onClick={() => props.onClick()}
    >
      <div class="flex w-full items-center gap-x-1.5">
        <DynamicValueIconTile
          icon={props.icon}
          iconClassList={{
            [props.iconColor !== undefined ? props.iconColor : getIconCategoryColor(props.category ?? "unknown")]: true,
          }}
          size="lg"
        />
        <div class="flex min-w-0 flex-col text-left">
          <Text as="h5" class="text-base-medium text-primary" truncate text={props.label} />
          <Show
            when={props.errors.length === 1}
            fallback={
              <Text
                class="text-small-medium text-status-error"
                truncate
                text={t(($) => $.VALIDATION_MENU_MULTIPLE_ERRORS, { count: props.errors.length })}
              />
            }
          >
            <Text class="text-small-medium text-status-error" truncate text={props.errors[0].message} />
          </Show>
        </div>
      </div>
    </button>
  );
};

export const GenericErrorCard: VoidComponent<GenericErrorCardProps> = (props) => <BaseErrorCard {...props} />;

type FieldErrorCardProps = {
  category: Category;
} & GenericErrorCardProps;
export const FieldErrorCard: VoidComponent<FieldErrorCardProps> = (props) => <BaseErrorCard {...props} />;
